import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinProperties',
})
export class JoinPropertiesPipe implements PipeTransform {
  /**
   * Transforms an array of objects or strings into a single string,
   * with each element separated by the specified splitter.
   *
   * @param list - The array to be transformed. It can contain either
   *               plain strings or objects.
   * @param propertyName - (Optional) The property name to extract from
   *                       each object in the array. If not provided,
   *                       the array elements themselves are used directly.
   * @param splitter - (Optional) The string to use as a separator.
   *                   Defaults to ', '.
   * @returns A string containing the concatenated values, separated by the splitter.
   */
  transform(list: any[], propertyName?: string, splitter: string = ', '): string {
    if (!list || !Array.isArray(list) || list.length === 0) {
      return '';
    }

    return list
      .map((item) => (propertyName ? item[propertyName] : item))
      .filter((item) => typeof item === 'string' && item)
      .join(splitter);
  }
}
